import Icon from 'wa-storybook/components/general/icon/icon';
import styles from './get-help-card.module.scss';

export type Props = {
  onClick: () => void;
};

export const GetHelpCard = ({ onClick }: Props) => {
  return (
    <div className={styles.wrapper}>
      <Icon
        className={styles['icon-call']}
        icon='Call'
        height='30px'
        width='30px'
      />

      <div className={styles['confidential-support-text']}>
        {polyglot.t('login.confidential_support_text')}
        <button
          type={'button'}
          data-hook='get-help-button'
          onClick={onClick}
          className={styles.cta}
        >
          {polyglot.t('login.confidential_support_action')}
        </button>
      </div>
    </div>
  );
};

GetHelpCard.displayName = 'GetHelpCard';

export default GetHelpCard;
